const SET_PARAMETERS_OPENING = 'AUTH/SET_PARAMETERS_OPENING';

export default function setParametersOpeningAction(date: Date) {
  return {
    type: SET_PARAMETERS_OPENING,
    payload: date
  };
}

export { SET_PARAMETERS_OPENING };